import { styled } from '@mui/system';

export const FileInfoCnt = styled('section')(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.up('sm')]: {
    alignItems: 'baseline'
  }
}));

export const FieldsCnt = styled('section')(({ theme }) => ({
  display: 'flex',
  flex: 1,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column'
  }
}));

export const ButtonCnt = styled('section')(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column'
  }
}));

export const FileNameField = styled('div')(({ theme }) => ({
  margin: theme.spacing(1),
  flex: 2
}));

export const FileDescriptionField = styled('div')(({ theme }) => ({
  margin: theme.spacing(1),
  flex: 3
}));
